"use client"

import React, { PropsWithChildren, useCallback, useEffect, useState } from "react"
import Cookies from "js-cookie"
import { XIcon } from "lucide-react"

import { ExitPopupCookieValue, UB_EXIT_POPUP_COOKIE_NAME } from "@/lib/exit-popup-cookies"

export interface ExitDialogProps extends PropsWithChildren {}

export default function ExitDialogClient(props: ExitDialogProps) {
  const [ecShown, setEcShown] = useState<boolean>(true)
  const [leaveDetected, setLeaveDetected] = useState<boolean>(false)

  const hideExitPopup = () => {
    setEcShown(true)
    Cookies.set(UB_EXIT_POPUP_COOKIE_NAME, "true", { expires: 7 })
  }

  const handleLeaveDetected = useCallback(
    (e: MouseEvent) => {
      if (!leaveDetected) {
        if (e.clientY < 10) {
          setLeaveDetected(true)
        }
      }
    },
    [leaveDetected]
  )

  useEffect(() => {
    const exitPopupCookieValue = Cookies.get(UB_EXIT_POPUP_COOKIE_NAME)
    const ecShownFromCookie = ExitPopupCookieValue.isEcShown(exitPopupCookieValue)
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setEcShown(ecShownFromCookie)
    // for debug use
    if (exitPopupCookieValue == "force") {
      setEcShown(false)
      setLeaveDetected(true)
    }
  }, [])

  useEffect(() => {
    if (!ecShown) {
      setTimeout(() => {
        document.addEventListener("mouseout", handleLeaveDetected)
      }, 1000)
    }
    return () => {
      document.removeEventListener("mouseout", handleLeaveDetected)
    }
  }, [ecShown, handleLeaveDetected, leaveDetected])

  return (
    <>
      {!ecShown && leaveDetected && (
        <div
          className={"fixed inset-0 z-modal-level flex flex-col items-center justify-center bg-black/90"}
          onClick={hideExitPopup}
        >
          <div className={"relative size-fit"}>
            <XIcon
              onClick={hideExitPopup}
              className="absolute top-0 right-0 size-5 cursor-pointer bg-white fill-black hover:bg-primary-hover"
            ></XIcon>

            <div className={"bg-white p-2"}>{props.children}</div>
          </div>
        </div>
      )}
    </>
  )
}
